export default "__VITE_ASSET__BIvWSVg2__"